/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { auditlogsListFacets } from "../funcs/auditlogsListFacets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAuditLogFacetsResult } from "../models/components/listauditlogfacetsresult.js";
import {
  ListAuditLogFacetsRequest,
  ListAuditLogFacetsSecurity,
} from "../models/operations/listauditlogfacets.js";
import { unwrapAsync } from "../types/fp.js";
export type AuditLogFacetsQueryData = ListAuditLogFacetsResult;

export function prefetchAuditLogFacets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAuditLogFacetsRequest | undefined,
  security?: ListAuditLogFacetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAuditLogFacetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAuditLogFacetsQuery(
  client$: GramCore,
  request?: ListAuditLogFacetsRequest | undefined,
  security?: ListAuditLogFacetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AuditLogFacetsQueryData>;
} {
  return {
    queryKey: queryKeyAuditLogFacets({
      projectSlug: request?.projectSlug,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function auditLogFacetsQueryFn(
      ctx,
    ): Promise<AuditLogFacetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(auditlogsListFacets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAuditLogFacets(
  parameters: {
    projectSlug?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "auditlogs", "listFacets", parameters];
}
